import { useCallback, useMemo, useState } from "react";
import { useAuth } from "@/components/AuthProvider";
import {
  clearAuthSession,
  formatUserDisplayName,
  hasAuthSession,
} from "@/utils/authStorage";

export function useSessionUser() {
  const { setAuthenticated, isAuthenticated } = useAuth();
  const [version, setVersion] = useState(0);

  const refresh = useCallback(() => setVersion((v) => v + 1), []);

  const session = useMemo(() => {
    void version;
    void isAuthenticated;

    const loggedIn = hasAuthSession();
    const fullName = formatUserDisplayName();

    return {
      isLoggedIn: loggedIn,
      displayName: loggedIn && fullName ? fullName : "Guest",
      showNotMe: loggedIn,
    };
  }, [version, isAuthenticated]);

  const signOutSession = useCallback(() => {
    clearAuthSession();
    setAuthenticated(false);
    refresh();
  }, [setAuthenticated, refresh]);

  return { ...session, signOutSession, refresh };
}
